import { createContext } from 'react';

const SharedHeaderContext = createContext(null);

export default SharedHeaderContext;
